<template>
  <div class="app-container">
    <Container
      :title="t('route.acceptanceBillsDetail')"
      :hasLine="true"
    >
      <template #main>
        <el-form
          label-width="680px"
          ref="cFormRef"
          label-position="left"
          style="margin-left:15%; font-size: 14px;"
        >
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.draftNo')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.draftNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.draftRange')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.draftRange }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('company.companyCode')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.companyCode }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.draftType')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ formatDraftType(detailData.draftType) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.splitFlag')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ formatSplitFlag(detailData.splitFlag) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.banendFlag')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ formatBanendFlag(detailData.banendFlag) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.issueDate')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.issueDate }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.bankName')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.bankName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.dueDate')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.dueDate }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.draftAmt')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ formatThousands(detailData.draftAmt) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </Container>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import { formatThousands } from '@/utils'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import {
  formatBanendFlag, formatDraftType, formatRequestEntrustPay, formatSplitFlag
} from '@/utils/acceptanceBillFormatUtil'
import Container from '@/components/form/container/Container.vue'
import { ElMessage } from 'element-plus'
import { getAvailableAcceptanceDetails } from '@/apis/accepted-bill/availableAcceptance'
import { AvailableAcceptanceModel } from '@/model/accepted-bill/availableAcceptanceModel'

export default defineComponent({
  name: 'AvailableAcceptanceDetail',
  methods: { formatThousands },
  components: {
    Container
  },
  setup() {
    const { t } = useI18n()
    const tableRef = ref()
    const id = useRoute().params.id.toString()
    const dataMap = reactive({
      detailData: {} as AvailableAcceptanceModel | null,
      async getData() {
        let acceptanceId
        try {
          acceptanceId = Number(id)
        } catch (error) {
          ElMessage({
            message: 'id 格式错误;' + id,
            type: 'error',
            duration: 2000
          })
          return
        }
        const data = await getAvailableAcceptanceDetails(acceptanceId)
        if (data && data.data) {
          dataMap.detailData = data.data
        } else {
          dataMap.detailData = null
          ElMessage({
            message: data?.msg,
            type: 'error',
            duration: 2000
          })
        }
      }
    })
    onMounted(() => {
      dataMap.getData()
    })
    return {
      t,
      tableRef,
      formatBanendFlag,
      formatSplitFlag,
      formatRequestEntrustPay,
      formatDraftType,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style
  scoped
  lang="scss"
>
.header-title {
  font-weight: bold;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}
</style>
